/* =====================================================
   INTERACTIONS.JS — Cursor, Nav Scroll, Marquee,
                     Kinetic Type, Magnetic Buttons
   ===================================================== */

(function () {
  'use strict';

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Custom Cursor ─────────────────────────────────── */
  if (!REDUCED && window.matchMedia('(pointer: fine)').matches) {
    const dot  = document.getElementById('cursor-dot');
    const ring = document.getElementById('cursor-ring');

    if (dot && ring) {
      let mx = -100, my = -100;
      let rx = -100, ry = -100;
      let raf;

      document.addEventListener('mousemove', e => {
        mx = e.clientX;
        my = e.clientY;
        dot.style.transform = `translate(${mx}px, ${my}px)`;
      });

      function animateRing() {
        rx += (mx - rx) * 0.12;
        ry += (my - ry) * 0.12;
        ring.style.transform = `translate(${rx}px, ${ry}px)`;
        raf = requestAnimationFrame(animateRing);
      }
      animateRing();

      // Grow ring on interactive elements
      const interactives = 'a, button, [role="button"], .btn, .card, .accordion__trigger';
      document.addEventListener('mouseover', e => {
        if (e.target.closest(interactives)) {
          ring.classList.add('cursor-ring--hover');
          dot.classList.add('cursor-dot--hover');
        }
      });
      document.addEventListener('mouseout', e => {
        if (e.target.closest(interactives)) {
          ring.classList.remove('cursor-ring--hover');
          dot.classList.remove('cursor-dot--hover');
        }
      });

      document.addEventListener('mouseleave', () => {
        dot.style.opacity  = '0';
        ring.style.opacity = '0';
      });
      document.addEventListener('mouseenter', () => {
        dot.style.opacity  = '1';
        ring.style.opacity = '1';
      });
    }
  }

  /* ── Nav: Transparent → Frosted on Scroll ──────────── */
  const nav = document.querySelector('.nav');
  if (nav) {
    const threshold = 80;
    let ticking = false;

    function updateNav() {
      if (window.scrollY > threshold) {
        nav.classList.add('nav--scrolled');
      } else {
        nav.classList.remove('nav--scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateNav);
        ticking = true;
      }
    }, { passive: true });

    updateNav();
  }

  /* ── Marquee: auto-duplicate content for seamless loop ─ */
  document.querySelectorAll('.marquee__track').forEach(track => {
    // Clone the inner content so the marquee loops seamlessly
    const content = track.innerHTML;
    track.innerHTML = content + content;
  });

  /* ── Kinetic Number Counter ────────────────────────── */
  function animateCounter(el) {
    const target = parseFloat(el.dataset.target);
    const duration = 1800;
    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    const decimals = el.dataset.decimals ? parseInt(el.dataset.decimals) : 0;
    const start = performance.now();

    function easeOutExpo(t) {
      return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    }

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const value = target * easeOutExpo(progress);
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  if (!REDUCED) {
    const counterObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    document.querySelectorAll('[data-counter]').forEach(el => {
      counterObserver.observe(el);
    });
  } else {
    // Just set final value
    document.querySelectorAll('[data-counter]').forEach(el => {
      const suffix = el.dataset.suffix || '';
      const prefix = el.dataset.prefix || '';
      const decimals = el.dataset.decimals ? parseInt(el.dataset.decimals) : 0;
      el.textContent = prefix + parseFloat(el.dataset.target).toFixed(decimals) + suffix;
    });
  }

  /* ── Horizontal Drag-Scroll for overflowing containers ─ */
  document.querySelectorAll('.drag-scroll').forEach(el => {
    let isDown = false, startX, scrollLeft;

    el.addEventListener('mousedown', e => {
      isDown = true;
      el.classList.add('is-dragging');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', () => { isDown = false; el.classList.remove('is-dragging'); });
    el.addEventListener('mouseup',    () => { isDown = false; el.classList.remove('is-dragging'); });

    el.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      el.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  });

  /* ── Staggered word reveal ─────────────────────────── */
  if (!REDUCED) {
    document.querySelectorAll('.word-reveal').forEach(el => {
      const words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words
        .map((w, i) => `<span class="word-reveal__word" style="transition-delay:${i * 60}ms">${w}</span>`)
        .join(' ');
    });

    const wordObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.word-reveal__word').forEach(w => {
            w.classList.add('word-reveal__word--visible');
          });
          wordObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    document.querySelectorAll('.word-reveal').forEach(el => wordObserver.observe(el));
  }

})();
